module.exports = __webpack_public_path__ + "img/logo.e45b1c98.png";